export default __webpack_public_path__ + "static/media/HHlong.79659f39.mp3";